export default "__VITE_ASSET__BdylHDDH__"